export enum OrderLevelDiscount {
    PERCENTAGE_OFF = "order_percentage_off",
    FREE_SHIPPING = "free_shipping",
    AMOUNT_OF = "amount_of",
    NET_TERMS_EXTENSION = "net_terms_extension",
}

export enum ProductLevelDiscount {
    PERCENTAGE_OFF = "product_percentage_off",
    AMOUNT_OFF_EACH = "amount_off_each",
    AMOUNT_OFF_SUBTOTAL = "amount_off_subtotal",
}
